import { render, staticRenderFns } from "./BulkOutsourcedCases.vue?vue&type=template&id=ac5167fe&"
import script from "./BulkOutsourcedCases.vue?vue&type=script&lang=js&"
export * from "./BulkOutsourcedCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports